var map = {
	"./ar/posts/index.vue": [
		3682,
		568,
		682
	],
	"./en/posts/index.vue": [
		834,
		568,
		834
	],
	"./fa/posts/index.vue": [
		2462,
		568,
		462
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4152;
module.exports = webpackAsyncContext;